import * as React from 'react';
import {
  ExpandMore,
  // UnfoldMore, Visibility, VisibilityOutlined
} from '@mui/icons-material';
import { AccordionDetails, AccordionSummary, Box, Typography, useTheme } from '@mui/material';

import { IBuildingTreeItemAction, IFloorVisualization, IZoneVisualization } from 'models';
import { EnhancedAccordion } from 'components/styled-mui';
import { BuildingTreeItemHeader, BuildingTreeZoneItem } from '.';

interface BuildingTreeFloorItemProps {
  floor: IFloorVisualization;
}

export const BuildingTreeFloorItem: React.FC<BuildingTreeFloorItemProps> = (props) => {
  const theme = useTheme();
  const { floor } = props;
  const [expanded, setExpanded] = React.useState<boolean>(false);

  const floorItemActions: Array<IBuildingTreeItemAction> = [
    // {
    //   tooltip: 'Show floor',
    //   icon: <VisibilityOutlined fontSize="inherit" />,
    //   onClick: () => {},
    // },
    // {
    //   tooltip: 'Show all zones',
    //   icon: <Visibility fontSize="inherit" />,
    //   onClick: () => {},
    // },
    // {
    //   tooltip: 'Expand all zones',
    //   icon: <UnfoldMore fontSize="inherit" />,
    //   onClick: () => {},
    // },
  ];

  return (
    <EnhancedAccordion
      disabled={floor.zones.size === 0}
      expanded={expanded}
      dividerColor={`${theme.palette.primary.light}60`}
    >
      <AccordionSummary
        expandIcon={floor.zones.size > 0 ? <ExpandMore color="primary" /> : null}
        onClick={() => {
          setExpanded((prev) => !prev);
        }}
      >
        <BuildingTreeItemHeader
          title={floor.name}
          subtitle={`(${floor.zones.size || 'No zone'})`}
          actions={floorItemActions}
          disabled={floor.zones.size === 0}
        />
      </AccordionSummary>

      {floor.zones.size > 0 && <AccordionDetails>{renderZoneItems(floor.zones)}</AccordionDetails>}
    </EnhancedAccordion>
  );
};

const renderZoneItems = (zones: Map<number, IZoneVisualization>) => {
  if (zones.size === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          paddingBottom: 2,
        }}
      >
        <Typography color="textSecondary" variant="body2">
          No zone
        </Typography>
      </Box>
    );
  }

  const items: Array<React.ReactNode> = [];

  zones.forEach((zone, key) => items.push(<BuildingTreeZoneItem key={`zone-${key}`} zone={zone} />));

  return items as Array<React.ReactNode>;
};
